var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVuesaxOutlineSmallcaps(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "{props.color}",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.86 5.93V4.42c0-.6-.49-1.1-1.1-1.1H3.83c-.6 0-1.1.49-1.1 1.1v1.51c0 .41-.34.75-.75.75s-.74-.34-.74-.75V4.42c0-1.43 1.17-2.6 2.6-2.6h12.92c1.43 0 2.6 1.16 2.6 2.6v1.51c0 .41-.34.75-.75.75s-.75-.34-.75-.75z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.55 18.1V3.32c0-.41.34-.75.75-.75s.75.34.75.75V18.1a.749.749 0 1 1-1.5 0z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.9 18.85c-.41 0-.75-.34-.75-.75s.34-.75.75-.75h5.58c.41 0 .75.34.75.75s-.34.75-.75.75H6.9zM21.26 12.45v-.8c0-.31-.26-.57-.57-.57h-7.01c-.41 0-.75-.34-.75-.75s.34-.75.75-.75h7.01c1.14 0 2.07.93 2.07 2.07v.8c0 .42-.33.75-.75.75-.41 0-.75-.34-.75-.75z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.33 21.43V10.87c0-.41.34-.75.75-.75s.75.34.75.75v10.56c0 .41-.34.75-.75.75s-.75-.34-.75-.75z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.94 22.18c-.41 0-.75-.34-.75-.75s.34-.75.75-.75h4.28c.41 0 .75.34.75.75s-.34.75-.75.75h-4.28z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVuesaxOutlineSmallcaps);
export default __webpack_public_path__ + "static/media/vuesax-outline-smallcaps.a76bc0bc448a5b8d93929263f284c489.svg";
export { ForwardRef as ReactComponent };